﻿import { Entity, MicroMClient } from "@mcurros2/microm";
import { IconRoute } from "@tabler/icons-react";
import { RutasDef } from "./RutasDef";

export const RutasIcon = IconRoute;
export const RutasHelpText = '* Aquí se encuentran las rutas. Los registros de esta tabla muestran el personal encargados de hacer los servicios en las multiples tiendas';

export class Rutas extends Entity<RutasDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new RutasDef(), parentKeys);
        super.Form = import('./RutasForm').then((module) => module.RutasForm);
        this.Title = "Rutas";
        this.HelpText = RutasHelpText;
        this.Icon = RutasIcon;
    }
}